<script setup>

  const props = defineProps({
    ann: {
      type: Object,
      required: true
    }
  })

  import { VideoStore } from '@/front/stores/video_store.js';
  const videoStore = VideoStore();

  const customStyle = props.ann.customStyle && JSON.parse(props.ann.customStyle) || {}

  const baseDesign = videoStore.video.design || {}
  const circleStyle = computed(() => {
    return {
      'backgroundColor': props.ann.background_color || customStyle.background_color || baseDesign.color,
      'width': '50px',
      'height': '50px',
      'backgroundImage': props.ann.background_image ? `url('${props.ann.background_image}')` : 'none',
      'backgroundSize': 'contain',
      'backgroundPosition': 'center',
      'backgroundRepeat': 'no-repeat',
    }
  })
  const ringStyle = computed(() => {
  
    return {
      'borderColor': props.ann.background_color || customStyle.background_color || baseDesign.color,
      'borderWidth': '4px',
      'min-width': '50px',
      'min-height': '50px',
    }
  })

  const isWhiteSpot = computed(() => {
    // Helper to normalize background color and check if "white" of any kind
    let value = props.ann.background_color
      if (!value) return false;
      const trimmed = value.toString().trim().toLowerCase();
      if (trimmed === "white") return true;
      if (trimmed === "#fff" || trimmed === "#ffffff") return true;
      // rgba(255,255,255,0) or 1 or variants (with/without spaces)
      if (trimmed.startsWith("rgba(") || trimmed.startsWith("rgb(")) {
        // Remove all spaces for easier matching
        const norm = trimmed.replace(/\s+/g, "");
        if (
          norm === "rgba(255,255,255,0)" ||
          norm === "rgba(255,255,255,1)" ||
          norm === "rgb(255,255,255)"
        ) {
          return true;
        }
      }
      // Allow some CSS oddities (e.g., "rgb(255 255 255)")
      if (trimmed.match(/^rgb\(\s*255\s*,?\s*255\s*,?\s*255\s*\)$/)) return true;
      return false;
  })
</script>

<template>
  <div class="w-full" :class="{'bg-gray-200 p-2 max-w-[80%] mx-auto': isWhiteSpot}">
    <div class="flex items-center justify-center min-h-[60px]" >
      <!-- <span class="spot-ring" :style="ringStyle"></span> -->
      <span class="spot-circle" :style="circleStyle"></span>
    </div>
    <div v-if="ann.caption || ann.extra || ann.internal_label" class="text-sm mt-2">
      <div v-if="ann.caption">{{ ann.caption }}</div>
      <div v-else-if="ann.extra">{{ ann.extra }}</div>
      <div v-else-if="ann.internal_label">{{ ann.internal_label }}</div>
    </div>
  </div>

</template>